package com.schoolconnect.app.util

import co.touchlab.kermit.Logger

private val schoolConnectLogger = Logger.withTag("SchoolConnect")

fun scLog(message: String, throwable: Throwable? = null) {
    if (!BuildConfig.isDebug()) return
    if (throwable != null) {
        schoolConnectLogger.e(throwable) { message }
    } else {
        schoolConnectLogger.d { message }
    }
}

fun scInfo(message: String) {
    schoolConnectLogger.i { message }
}
